import { SettingField } from "./SettingsSection";

export type SettingCard = {
  // Key in central-api (GET/POST /api/settings/:key); any new key works without backend changes
  key: string;
  icon: string;
  title: string;
  description?: string;
  fields: SettingField[];
};

export type SettingGroup = {
  title: string;
  cards: SettingCard[];
};

/**
 * Everything shown on the Einstellungen page. To add a setting, add a card (or a group)
 * here; the page renders it, loads and saves it under its key.
 *
 * Field types: "text", "email", "password", "toggle". A card with only toggles saves on every
 * switch; any other card gets a "Speichern" button.
 */
export const SETTING_GROUPS: SettingGroup[] = [
  {
    title: "Zugangsdaten",
    cards: [
      {
        // Read by parser-api when it has to log in to Auto1 again
        key: "auto1-credentials",
        icon: "🔑",
        title: "Auto1",
        description:
          "Händler-Konto, mit dem der Parser Auto1-Inserate abruft. Neue Daten werden beim nächsten Login des Parsers verwendet.",
        fields: [
          {
            name: "login",
            label: "E-Mail",
            type: "email",
            placeholder: "name@beispiel.de",
          },
          { name: "password", label: "Passwort", type: "password" },
        ],
      },
    ],
  },
  {
    title: "Benachrichtigungen",
    cards: [
      {
        // Read by health-checker (via central-api) before sending the daily email
        key: "email-if-search-url-is-missing",
        icon: "✉️",
        title: "E-Mail",
        description: "Änderungen werden sofort gespeichert.",
        fields: [
          {
            name: "searchUrlNotifications",
            label: "Fehlende Vergleichslinks",
            hint: "E-Mail mit den Autos von gestern, für die kein Vergleichslink gefunden wurde.",
            type: "toggle",
            defaultValue: true,
          },
        ],
      },
      {
        // Read by health-checker (monitor.service.ts) before sending an issue email
        key: "service-issue-email",
        icon: "🚨",
        title: "Störungen",
        description:
          "E-Mails, wenn ein Service ausfällt, der Speicher voll wird oder der Parser keine Autos mehr schickt.",
        fields: [
          {
            name: "intervalHours",
            label: "Höchstens eine E-Mail alle … Stunden",
            hint: "Pro Störungsart, z. B. 1 = stündlich, 5 = alle 5 Stunden.",
            type: "number",
            min: 1,
            defaultValue: 1,
          },
        ],
      },
    ],
  },
];
